import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { products, categories } from '../data/products';
import './Shop.css';

const Shop = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState(
    searchParams.get('category') || 'all'
  );

  const filteredProducts = selectedCategory === 'all'
    ? products
    : products.filter(product => product.category === selectedCategory);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    if (categoryId === 'all') {
      setSearchParams({});
    } else {
      setSearchParams({ category: categoryId });
    }
  };

  return (
    <div className="shop">
      <div className="shop-header">
        <div className="container">
          <h1 className="shop-title fade-in">
            Shop Collection
            <span className="title-kanji">ショップ</span>
          </h1>
          <p className="shop-subtitle">Discover Premium Japanese Streetwear</p>
        </div>
      </div>

      <div className="shop-content container">
        <aside className="shop-sidebar slide-in">
          <h3 className="sidebar-title">Categories</h3>
          <ul className="category-list">
            {categories.map(category => (
              <li key={category.id}>
                <button
                  className={`category-button ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => handleCategoryChange(category.id)}
                >
                  <span>{category.name}</span>
                  <span className="category-kanji">{category.nameJp}</span>
                </button>
              </li>
            ))}
          </ul>

          <div className="sidebar-info">
            <h4>Premium Quality</h4>
            <p>Every piece is crafted with attention to detail and traditional Japanese aesthetics.</p>
          </div>
        </aside>

        <main className="shop-main">
          <div className="shop-results">
            <p className="results-count">
              {filteredProducts.length} {filteredProducts.length === 1 ? 'Product' : 'Products'}
            </p>
          </div>

          <div className="products-grid">
            {filteredProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-products">
              <p>No products found in this category.</p>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default Shop;
